export default __webpack_public_path__ + "fonts/SuisseIntl-RegularItalic-WebXL.woff";